import React, { useEffect, useState } from "react"
import { getText } from "../utils/file-handling"

/* eslint-disable react/no-danger */

function TnCText({ textFile }) {
  const [content, setContent] = useState("")

  useEffect(() => {
    async function setText() {
      const text = await getText(textFile)
      setContent(text)
    }
    setText()
  }, [textFile])

  return (
    <div className="modal-body" dangerouslySetInnerHTML={{ __html: content }} />
  )
}

export default TnCText
